module.exports = __webpack_public_path__ + "static/media/ic-cam-loading.84e6b098.svg";